export default function(obj = {}, keys = []) {
  return keys.every(key => obj[key] === undefined || obj[key] === null || obj[key] === '');
}



// WEBPACK FOOTER //
// ./src/utils/allUnset.js